exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2JdbCdTxjb_M0jrijvJ_X-{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row;flex-flow:row;-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0}._1WSKvy8HbKSzb-ak9VAoK7{min-width:600px}html[dir] ._1QcnU8kS5utoAw_wLNQxy7{margin:25px}html[dir] ._1PkfpE_LQsp7mKNAHwHzXO{margin:10px 50px}", ""]);
// Exports
exports.locals = {
	"container": "_2JdbCdTxjb_M0jrijvJ_X-",
	"table": "_1WSKvy8HbKSzb-ak9VAoK7",
	"rightPanel": "_1QcnU8kS5utoAw_wLNQxy7",
	"button": "_1PkfpE_LQsp7mKNAHwHzXO"
};